import React from "react";
import styles from "./idea.module.css";
import { useEffect, useRef, useState } from "react";

function Idea() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.idea_wrapper}>
      <div className={styles.idea_container}>
        <div
          ref={pRef}
          className={`${styles.ideaTitle} ${isVisible ? styles.show : ""}`}>
          <h2>Idea</h2>
          <p>
            Why choosing <span>Business Corners</span> ?
          </p>
        </div>
        <div className={styles.ideaLine}></div>
        <div className={styles.ideaText}>
          <div className={styles.left}>
            <p
              ref={pRef}
              className={`${styles.left1} ${isVisible ? styles.show : ""}`}>
              <span className={styles.icon}>B</span>At Business Corners, we
              focus on connecting the four keys corners of business: buyer,
              supplier, market, product and service. We help companies access
              the European market by establishing a stable supply chain from the
              supplier end, ensuring their products reach the market
              efficiently.
            </p>

            <p
              ref={pRef}
              className={`${styles.left1} ${isVisible ? styles.show : ""}`}>
              {" "}
              {/* chain from the supplier end, ensuring their products reach the
              market efficiently. Our */}
            </p>
          </div>

          <p
            ref={pRef}
            className={`${styles.right} ${isVisible ? styles.show : ""}`}>
            Our active involvement with products at the product end helps expand
            their market size and visibility, while at the market end, we ensure
            high-quality goods and services meet the demands of European buyers.
            By balancing these four corners, we create a reliable and seamless
            process that fosters strong, lasting business relationships across
            the globe.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Idea;
